import { render, staticRenderFns } from "./ShareCenter.vue?vue&type=template&id=0d23f9c6&scoped=true"
import script from "./ShareCenter.vue?vue&type=script&lang=js"
export * from "./ShareCenter.vue?vue&type=script&lang=js"
import style0 from "./ShareCenter.vue?vue&type=style&index=0&id=0d23f9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d23f9c6",
  null
  
)

export default component.exports